<i class="pi pi-copy style-icon" (click)="copyToClipboard(textToCopy)"></i>
